declare global {
  interface Window {
    Capacitor?: any;
    androidBridge?: {
      postMessage: (message: string) => void;
    };
  }
}

export interface SunmiPrinterPlugin {
  init(): Promise<void>;
  printText(options: { text: string }): Promise<void>;
}

function cap(): any {
  return window.Capacitor;
}

function nativePromise(pluginId: string, methodName: string, options: any) {
  const c = cap();
  if (!c || typeof c.nativePromise !== 'function') {
    throw new Error('Capacitor bridge not ready');
  }
  return c.nativePromise(pluginId, methodName, options || {});
}

export const SunmiPrinter: SunmiPrinterPlugin = {
  init: () => nativePromise('SunmiPrinter', 'init', {}),
  printText: (options) => nativePromise('SunmiPrinter', 'printText', options),
};

export function isRunningInWaitronConnect(): boolean {
  const c = cap();
  return (
    !!c &&
    typeof c.nativePromise === 'function' &&
    typeof window.androidBridge?.postMessage === 'function'
  );
}
